import React, {useEffect} from 'react';
import {useHistory, useLocation} from 'react-router';
import {PATH} from 'constants/common';
import PageTitle from 'components/ui/PageTitle/PageTitle';
import Button from 'components/ui/Button';
import {useAuth} from 'context/auth-context';
import {createOnboardingUrlPath} from 'components/pages/OnboardingPage/onboardingSteps';
import {StepTypes} from 'types/onboarding';
import {BP_CONTRACTS_CACHE} from 'constants/cache';
import {useBusinessPartner} from 'context/business-partner-context';
import {IOnboardingContract, useGetCurrentContract} from 'api/business-partner';
import AmnisLoader from 'components/ui/AmnisLoader/AmnisLoader';

import styles from './ContractSigningRedirectPage.module.scss';
import {useQueryClient} from '@tanstack/react-query';

const PROVIDERS: Record<string, string> = {
    skribble: 'Skribble',
    docuSign: 'DocuSign',
};

const ContractSigningRedirectPage = () => {
    const location = useLocation();
    const queryClient = useQueryClient();
    const history = useHistory();
    const {user} = useAuth();
    const {activeBusinessPartner} = useBusinessPartner();
    const params = new URLSearchParams(location.search);
    const {data: contract, isLoading: isContractLoading} =
        useGetCurrentContract(activeBusinessPartner);

    useEffect(() => {
        if (!contract) return;

        if (params.get('event') === 'signing_complete') {
            queryClient.setQueryData<IOnboardingContract>(
                [BP_CONTRACTS_CACHE, {id: activeBusinessPartner['@id']}],
                {...contract, status: 'signed'},
            );
            history.push(createOnboardingUrlPath(StepTypes.FILE_UPLOADS));
        }
    }, [activeBusinessPartner, contract, history, params]);

    if (isContractLoading) {
        return <AmnisLoader />;
    }

    return (
        <div className={styles.container}>
            <PageTitle>Contract signiture error</PageTitle>
            <div>
                <p>
                    There was an error, when you tried to sign your contract
                    on&nbsp;
                    <var data-var="provider">
                        {PROVIDERS[params.get('provider')!]}
                    </var>
                    . If you want to try again, please click the button or get
                    in contact with us.
                </p>
                <Button
                    onClick={() => {
                        history.push(
                            user
                                ? createOnboardingUrlPath(
                                      StepTypes.CONTRACT_SIGN,
                                  )
                                : PATH.LOGIN,
                        );
                    }}
                >
                    {user ? 'Retry' : 'Login'}
                </Button>
            </div>
        </div>
    );
};

export default ContractSigningRedirectPage;
